/**
 * Feature catalog — the single brand-agnostic source of truth for each feature's
 * route name, default label, and icon.
 *
 * Today this data is split three ways (nav `tabs` in DefaultLayout, `shortcuts`
 * in HomeView, and route titles in routes.ts). This catalog consolidates it:
 * - `routeName` is the Vue Router `name` (the join key to routes.ts).
 * - `defaultLabel` is the current nav-drawer label.
 * - `defaultPageTitle` is the current page heading / route `meta.title`.
 * - `icon` is the `mdi-*` icon used by the feature's home card.
 *
 * Portals override labels/titles/icons where they differ; absent an override the
 * catalog default is used.
 */
import type { FeatureKey, IFeatureCatalogEntry } from './portal.types'

export const FEATURE_CATALOG: Record<FeatureKey, IFeatureCatalogEntry> = {
  home: {
    routeName: '/',
    defaultLabel: 'Home',
    defaultPageTitle: 'Home',
    icon: 'mdi-home-outline',
  },
  documents: {
    routeName: 'documents',
    defaultLabel: 'Documents',
    defaultPageTitle: 'Product Documents',
    icon: 'mdi-notebook-outline',
  },
  software: {
    routeName: 'software',
    defaultLabel: 'Software',
    defaultPageTitle: 'Legacy Software Packages',
    icon: 'mdi-xml',
  },
  hardware: {
    routeName: 'hardware',
    defaultLabel: 'Hardware',
    defaultPageTitle: 'Reference Design Kits',
    icon: 'mdi-memory',
  },
  training: {
    routeName: 'training',
    defaultLabel: 'Training',
    defaultPageTitle: 'Training Materials',
    icon: 'mdi-school-outline',
  },
  link_budget: {
    routeName: 'link-budget',
    defaultLabel: 'Link Budget',
    defaultPageTitle: 'Link Budget Calculator',
    icon: 'mdi-calculator',
  },
  knowledge_base: {
    routeName: 'knowledge-base',
    defaultLabel: 'Knowledge Base',
    defaultPageTitle: 'Knowledge Base',
    icon: 'mdi-book-open-outline',
  },
  legal: {
    routeName: 'legal',
    defaultLabel: 'Legal',
    defaultPageTitle: 'Legal',
    icon: 'mdi-gavel',
  },
}
